<template>
    <div>
        <div v-for="product in products" :key="product.prod_id">
            <PropertyCaseCard :product="product" v-if="product.prod_type === 'property'"/>
            <MortgageCaseCard :product="product" v-if="product.prod_type === 'mortgage'"/>
            <PersonalLoanCaseCard :product="product" v-if="product.prod_type === 'personal_loan'"/>
            <InsuranceCaseCard :product="product" v-if="product.prod_type === 'insurance'"/>
            <RefinancingCaseCard :product="product" v-if="product.prod_type === 'refinance'"/>
            <OtherLoanCaseCard :product="product" v-if="product.prod_type === 'other'"/>
            <SolicitorCaseCard :product="product" v-if="product.prod_type === 'solicitor'"/>
            <MhlvCaseCard :product="product" v-if="product.prod_type === 'mhlv'"/>
        </div>
        <b-card no-body v-if="is_loading" v-loading="is_loading">
            <div class="bg-light p-5 text-center rounded">
            </div>
        </b-card>
        <b-card no-body v-if="products.length === 0 && !is_loading">
            <div class="bg-light p-3 text-center rounded">
                No case found.
            </div>
        </b-card>
        <ComfirmGenerateCommissionModal ref="confirm-modal" />
    </div>
</template>
<script>
    import PropertyCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/PropertyCaseCard'
    import MortgageCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/MortagageCase/MortgageCaseCard'
    import PersonalLoanCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/PersonalLoanCase/PersonalLoanCaseCard'
    import InsuranceCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/InsuranceCase/InsuranceCaseCard'
    import RefinancingCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/RefinancingCase/RefinancingCaseCard'
    import OtherLoanCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/OtherLoanCase/OtherLoanCaseCard'
    import SolicitorCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/SolicitorCase/SolicitorCaseCard'
    import MhlvCaseCard from '@/views/CustomerProfile/CustomerProfileDetails/CenterProfileDetails/CasesCards/MhlvCase/MhlvCaseCard'
    import ComfirmGenerateCommissionModal from '@/views/Cases/Modals/ComfirmGenerateCommissionModal'

    import {
        notifyFunctionMixin,
        helperFunctionMixin,
        axios,
        services,
        getHeader
    } from '@/assets/js/httpImports.js'
    import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
		import { mapActions } from 'pinia'
    import { useProductStore } from '@/stores/productStore'
    
    export default {
        components: {
            MortgageCaseCard,
            PropertyCaseCard,
            PersonalLoanCaseCard,
            InsuranceCaseCard,
            RefinancingCaseCard,
            OtherLoanCaseCard,
            SolicitorCaseCard,
            MhlvCaseCard,
            ComfirmGenerateCommissionModal,
        },
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        data(){
            return{
                is_loading: false,
                products: [],
            }
        },
        mounted(){
            caseEventBus.$on('refresh-cases', this.getCases);
        },
        beforeUnmount(){
            EventBus.$off('refresh-cases', this.getCases)
        },
        methods: {
					...mapActions(useProductStore, ['getProducts']),
            async getCases(){
							  try{
                    this.is_loading = true
										this.products = [];
										let resp = await this.getProducts({version:2,paginate:'no_paginate',search: {prod_customer_id:this.$route.params.customer_id}});
										this.products = _gHlp.getValue(resp, 'data');
                    this.is_loading = false
                }catch(e){
                    this.is_loading = false
                    this.errorFunction(e)
                }
            }
        },
        created(){
            this.getCases(this.$route.params.customer_id)
        },
    }

</script>